import React from "react";
import LandingPage from "./landingPage";
import ContactUs from "./contactUs";
import AboutUs from "./aboutUs";

export default function PageSelection(props) {
    const { selection, setSelection } = props

    if (selection === "aboutUs") {
        return <AboutUs setSelection={setSelection} />
    } else if (selection === "contactUs") {
        return <ContactUs setSelection={setSelection} />;
    } else {
        return <LandingPage setSelection={setSelection} />;
    }
}